import React from "react";
import { Route, Redirect } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";

const checkUser = () => {
  let user = reactLocalStorage.getObject("userData");
  console.log("user", user);
  if (user != null && Object.keys(user).length > 0) {
    return false;
  } else {
    return true;
  }
};

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      // console.log("userData", reactLocalStorage.getObject("userData"));
      // console.log("userData", checkUser());

      if (isAuthProtected && checkUser()) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

export default AppRoute;
